// extracted by mini-css-extract-plugin
export default {"wrapper":"description-input-wrapper_wrapper__3mXX2","inputContainer":"description-input-wrapper_inputContainer__VP7yV","iconQuestion":"description-input-wrapper_iconQuestion__9flKz"};